const buttons = document.querySelectorAll('.video-button');
const videoModal = document.querySelector('.webinar-video');
const iframe = document.querySelector('.webinar-video__frame');
const html = document.querySelector('html');

// перетворює YouTube URL → embed URL
function getYoutubeEmbed(url) {
    try {
        const u = new URL(url);

        if (u.hostname.includes('youtu.be')) {
            return `https://www.youtube.com/embed/${u.pathname.slice(1)}`;
        }

        if (u.hostname.includes('youtube.com')) {
            return `https://www.youtube.com/embed/${u.searchParams.get('v')}`;
        }

        return null;
    } catch (e) {
        return null;
    }
}

// запуск відео
function playVideo(url) {
    const embed = getYoutubeEmbed(url);
    if (!embed) return;

    iframe.src = embed + '?autoplay=1';
    videoModal.classList.add('active');
    html.classList.add('hidden');
}

// зупинка відео
function stopVideo() {
    iframe.src = '';
    videoModal.classList.remove('active');
    html.classList.remove('hidden');
}

// клік по кнопках
buttons.forEach(button => {
    button.addEventListener('click', (e) => {
        e.preventDefault(); // щоб не переходило по href

        const url = button.getAttribute('href');
        playVideo(url);
    });
});

// закриття по кліку на фон
videoModal.addEventListener('click', (e) => {
    if (e.target === videoModal) {
        stopVideo();
    }
});